import { useEffect, useState } from 'react'

import { useParams, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

// Component
import MainHeader from '../components/MainHeader'
import GmCard from '../components/playerInterface/GmCard'
import PlayerStats from '../components/playerInterface/PlayerStats'
import ContractInfo from '../components/playerInterface/ContractInfo'
import Loader from '../components/Loader'
import PlayerInfoBottom from '../components/PlayerInfoBottom'

import { getRosterPlayer } from '../redux/actions/rosterAction'

const PlayerInterface = () => {
  const SETTING = useSelector((state) => state?.user?.setting)
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState({
    player: {},
    news: null,
    activePlayers: [],
    practicePlayers: [],
    reservedPlayers: [],
  })

  const { id } = useParams()
  const { state } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
    getData()
  }, [id])

  const getData = async () => {
    setLoading(true)
    const res = await getRosterPlayer({
      id,
      date: SETTING?.date,
      team: state?.teamId,
    })
    if (res) {
      setData(res)
    }
    setLoading(false)
  }

  return (
    <div className='player_interface_container'>
      <MainHeader headingAndDate={false} />

      <hr className='divider' />

      {loading ? (
        <Loader />
      ) : (
        <>
          {state?.teamId && (
            <div className='viewing_roster_heading'>
              <h2>Your are viewing {state?.teamName || 'other team'} rosters.</h2>
            </div>
          )}

          <GmCard
            playerData={data?.player}
            activePlayers={data?.activePlayers}
            practicePlayers={data?.practicePlayers}
            reservedPlayers={data?.reservedPlayers}
            getData={getData}
            news={data?.news}
            bidWinningPage={state?.teamId ? true : false}
            isReserve={state?.isReserve}
          />

          <PlayerInfoBottom player={data?.player?.player_id} />

          <section className='player_info_container'>
            <PlayerStats />
            <ContractInfo data={data?.player?.player_id?.contractInfo} />
          </section>
        </>
      )}

      {/* <PlayerInterfacePopup /> */}
    </div>
  )
}

export default PlayerInterface
